
import DrawBase from "../DrawBase"
import EditAssaultDirection from "./EditAssaultDirection"
import StyleUtil from "@/utils/cesiumBD/utils/StyleUtil.js"
class DrawAssaultDirection extends DrawBase {

    constructor(options) {
        super(options);
    }

    getTypeName() {
        return "突击方向";
    }


    getType() {
        return "polygon_Nor";
    }

    getEditInterface(){
        return EditAssaultDirection;
    }

    checkLeftClick() {
        if (this.positionsTemp.length <= 1) {
            return true;
        }
        return false;
    }

    checkMouseMove() {
        if (this.positionsTemp.length <= 1) {
            return false;
        }
        return true;
    }

    addDynamicGraph(entity) {
        var $this = this;
        var positionsArr = undefined;
        var positions=[];
        var hierarchyProperty = new $this.Cesium.CallbackProperty(function () {
            $this.calculateKeyPositions();
            if (!$this.isStarted && !positionsArr) {
                positionsArr = $this.positions.slice();
            }
            positions = positionsArr ? positionsArr : $this.positions;
            return new $this.Cesium.PolygonHierarchy($this.computeDrawstraightArrow(positions));

        }, false);

        var polygon = this.createPolygon(hierarchyProperty);
        entity.polygon = polygon;
    }

    
    loadDynamicGraph(entity, data) {
        var $this = this;
        var positions = JSON.parse(data.editPositions);
        var hierarchyProperty = new $this.Cesium.CallbackProperty(function () {
            return new $this.Cesium.PolygonHierarchy($this.computeDrawstraightArrow(positions));

        }, true);

        var polygon = this.createPolygon(hierarchyProperty);
        entity.polygon = polygon;
        StyleUtil.setStyle2Entity(JSON.parse(data.styleAttr), entity, "polygon")
    }

    //计算坐标点
    computeDrawstraightArrow(positions) {
        var $this = this;
        var length = positions.length;
        var p1 = positions[0];
        var p2 = positions[length - 1];
        var firstPoint = $this.cartesianToLatlng(p1);
        var endPoints = $this.cartesianToLatlng(p2);
        var arrow = [];
        var res = $this.fineArrow([firstPoint[0], firstPoint[1]], [endPoints[0], endPoints[1]]);
        for (var i = 0; i < res.length; i++) {
            var cart3 = new $this.Cesium.Cartesian3(res[i].x, res[i].y, res[i].z);
            arrow.push(cart3);
        }

        return arrow;
    }

    //箭头配置函数
    fineArrowDefualParam() {
        return {
            tailWidthFactor: 0.2,
            neckWidthFactor: 0.25,
            headWidthFactor: 0.3,
            headAngle: Math.PI / 4,
            neckAngle: Math.PI * 0.17741
        }
    }
    fineArrow(tailPoint, headerPoint) {
        var $this = this;
        if ((tailPoint.length < 2) || (headerPoint.length < 2)) return;
        //画箭头的函数
        let tailWidthFactor = $this.fineArrowDefualParam().tailWidthFactor;
        let neckWidthFactor = $this.fineArrowDefualParam().neckWidthFactor;
        let headWidthFactor = $this.fineArrowDefualParam().headWidthFactor;
        let headAngle = $this.fineArrowDefualParam().headAngle;
        let neckAngle = $this.fineArrowDefualParam().neckAngle;
        var o = [];
        o[0] = tailPoint;
        o[1] = headerPoint;
        var e = o[0],
            r = o[1],
            n = $this.getBaseLength(o),
            g = n * tailWidthFactor,
            //尾部宽度因子
            i = n * neckWidthFactor,
            //脖子宽度银子
            s = n * headWidthFactor,
            //头部宽度因子
            a = $this.getThirdPoint(r, e, Math.PI / 2, g, !0),
            l = $this.getThirdPoint(r, e, Math.PI / 2, g, !1),
            u = $this.getThirdPoint(e, r, headAngle, s, !1),
            c = $this.getThirdPoint(e, r, headAngle, s, !0),
            p = $this.getThirdPoint(e, r, neckAngle, i, !1),
            h = $this.getThirdPoint(e, r, neckAngle, i, !0),
            d = [];
        d.push(a[0], a[1], p[0], p[1], u[0], u[1], r[0], r[1], c[0], c[1], h[0], h[1], l[0], l[1], e[0], e[1]);
        return $this.Cesium.Cartesian3.fromDegreesArray(d);
    }

    getBaseLength(t) {
        return Math.pow(this.wholeDistance(t), .99)
    }

    wholeDistance(t) {
        for (var o = 0, e = 0; e < t.length - 1; e++) o += this.distance(t[e], t[e + 1]);
        return o
    }

    distance(t, o) {
        return Math.sqrt(Math.pow(t[0] - o[0], 2) + Math.pow(t[1] - o[1], 2))
    }

    getThirdPoint(t, o, e, r, n) {
        var g = this.getAzimuth(t, o),
            i = n ? g + e : g - e,
            s = r * Math.cos(i),
            a = r * Math.sin(i);
        return [o[0] + s, o[1] + a]
    }

    getAzimuth(t, o) {
        var e, r = Math.asin(Math.abs(o[1] - t[1]) / this.distance(t, o));
        return o[1] >= t[1] && o[0] >= t[0] ? e = r + Math.PI : o[1] >= t[1] && o[0] < t[0] ? e = 2 * Math.PI - r : o[1] < t[1] && o[0] < t[0] ? e = r : o[1] < t[1] && o[0] >= t[0] && (e = Math.PI - r), e
    }

}

export default DrawAssaultDirection;